import { Component, createRef, Fragment } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import Select from "react-select";
import Swal from "sweetalert2";
import PaginateCard from "../../../../components/PaginateCard";
import PrintLink from "../../../../components/Shipment/Factor/PrintLink";
import PrintLabelButton from "../../../../components/Shipment/Label/PrintLabelButton";
import ExcelDownload from "../../../../components/tools/ExcelDownload";
import CompanyEnum from "../../../../enums/CompanyEnum";
import getShipmentStatus from "../../../../function/getShipmentStatus";
import {
  getMethod,
  handleEnter,
  postRequestByAuth,
} from "../../../../function/helper";
import Loader from "../../newLetter/Loader";
import DownloadReport from "./DownloadReport";
import findBarcode from "./functions/findBarcode";
import style from "./myPackTableList.module.css";
import OrderDetailModal from "./OrderDetailModal";

export default class MyPacksTablePage extends Component {
  state = {
    users: [],
    showNumber: 10,
    pageNumber: 1,
    searchText: "",
    active: 1,
    items: [],
    paginationlength: 1,
    startNumber: 0,
    showModal: false,
    myParts: [],
    UI: "",
    count: 0,
    startDate: "",
    endDate: "",
    numberParcel: "",
    componyId: "",
    status: "",
    weight: "",
    getterName: "",
    getterProvince: "",
    getterCity: "",
    senderName: "",
    senderProvince: "",
    senderCity: "",
    showSearchBox: false,
    method_payment: "",
    listServices: [],
    provinces: [],
    cityOptionReciverMyPack: [],
    cityOptionSenderMyPack: [],
    checkBoxesValue: [],
    selectedValue: [],
    loading: false,
  };

  setChecked(value, index, id) {
    const newCheckBox = this.state.checkBoxesValue;
    if (value === true) {
      this.state.selectedValue.push(id);
    } else if (value === false) {
      this.setState({
        selectedValue: this.state.selectedValue.filter(item => item !== id),
      });
    }
    newCheckBox[index] = value;
    this.setState({
      checkBoxesValue: newCheckBox,
    });
  }

  selectAll() {
    const newCheckBox = [];
    const newCheckBoxValue = [];

    if (this.state.checkBoxesValue.length === this.state.selectedValue.length) {
      for (let i = 0; i < this.state.checkBoxesValue.length; i++) {
        newCheckBox.push(false);
        newCheckBoxValue.length = 0;
      }
    } else {
      for (let i = 0; i < this.state.checkBoxesValue.length; i++) {
        newCheckBox.push(true);
        newCheckBoxValue.push(this.state.users[i].factor.id);
      }
    }
    this.setState({
      checkBoxesValue: newCheckBox,
      selectedValue: newCheckBoxValue,
    });
  }

  constructor(props) {
    super(props);
    this.myRef = createRef();
  }

  async getListServices() {
    const response = await getMethod("/componyservices/v1/all");
    this.setState({ listServices: response });
  }

  async getProvince() {
    const province = await getMethod("/address/v1/province/show/1");

    this.setState({ provinces: province.data });
  }

  async getCitiesMyPack(id, string) {
    if (id) {
      if (string === "reciver") {
        const cityy = await getMethod("/address/v1/city/show/" + id);
        this.setState({ getterProvince: id });
        const optionCity = [{ value: "", label: "..." }];
        for (let i = 0; i < cityy.data.length; i++) {
          optionCity.push({
            value: cityy.data[i].id,
            label: cityy.data[i].faName,
          });
        }
        this.setState({ cityOptionReciverMyPack: optionCity });
      } else if (string === "sender") {
        const cityy = await getMethod("/address/v1/city/show/" + id);
        this.setState({ senderProvince: id });
        const optionCity = [{ value: "", label: "..." }];
        for (let i = 0; i < cityy.data.length; i++) {
          optionCity.push({
            value: cityy.data[i].id,
            label: cityy.data[i].faName,
          });
        }
        this.setState({ cityOptionSenderMyPack: optionCity });
      }
    }
  }

  async getData() {
    const body = {
      startDate: this.state.startDate.toString(),
      endDate: this.state.endDate.toString(),
      numberParcel: this.state.numberParcel,
      componyId: this.state.componyId,
      status: this.state.status,
      weight: this.state.weight,
      getterName: this.state.getterName,
      getterProvince: this.state.getterProvince,
      getterCity: this.state.getterCity,
      senderName: this.state.senderName,
      senderProvince: this.state.senderProvince,
      senderCity: this.state.senderCity,
      method_payment: this.state.method_payment,
    };
    this.setState({ loading: true });
    const datas = await postRequestByAuth(
      `/totalpost/v1/mypart?numberpage=${this.state.pageNumber}&numberitems=${this.state.showNumber}`,
      body
    );
    this.setState({ loading: false });

    if (datas && datas.status === 200) {
      const newCheckBox = [];
      for (let i = 0; i < datas.data.data.all.length; i++) {
        newCheckBox.push(false);
      }
      this.setState({
        UI: datas.data.data.UI,
        users: datas.data.data.all,
        checkBoxesValue: newCheckBox,
        count: datas.data.data.count,
        paginationlength: datas.data.data.number,
        startNumber: (this.state.pageNumber - 1) * this.state.showNumber + 1,
      });
    } else {
      Swal.fire({
        icon: "error",
        text: datas?.data?.message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
  }

  setInputNumber = event => {
    this.setState(
      {
        showNumber: event.target.value,
        pageNumber: 1,
      },
      () => {
        this.getData();
      }
    );
  };

  componentDidMount() {
    this.getData();
    this.getListServices();
    this.getProvince();
  }

  showPartsInModal = i => {
    this.setState({
      myParts: this.state.users[i].parts,
      showModal: true,
      order: this.state.users[i].factor,
    });
  };

  render() {
    const filter = (
      <Card className="mb-3 mx-2">
        <button
          className="btn-warning-style d-flex align-items-center justify-content-center"
          type="button"
        >
          جستجوی گزارش
        </button>
        <div>
          <div className="p-2">
            <Form>
              <Form.Group className="">
                <Row className="mt-2">
                  <Col lg={6} md={6} sm={12}>
                    <Form.Label> از تاریخ:</Form.Label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-right"
                      style={{ width: "100%", height: "2.2rem" }}
                      name="sDateMyPack"
                      onChange={value => {
                        this.setState({
                          startDate: value ? new DateObject(value) : "",
                        });
                      }}
                    />
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <Form.Label> تا تاریخ:</Form.Label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-right"
                      style={{ width: "100%", height: "2.2rem" }}
                      name="eDateMyPack"
                      onChange={value => {
                        this.setState({
                          endDate: value ? new DateObject(value) : "",
                        });
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col lg={6} md={6} sm={12}>
                    <Form.Label> شماره بارنامه:</Form.Label>
                    <Form.Control
                      type="text"
                      name="numberParcel"
                      value={this.state.numberParcel}
                      onChange={e =>
                        this.setState({ numberParcel: e.target.value })
                      }
                    />
                  </Col>

                  <Col md={6} sm={12}>
                    <Form.Label>سرویس دهنده:</Form.Label>
                    <Form.Select
                      type="text"
                      name="componyId"
                      value={this.state.componyId}
                      onChange={e =>
                        this.setState({ componyId: e.target.value })
                      }
                    >
                      <option value="">همه</option>
                      {Object.keys(CompanyEnum).map(item => (
                        <option key={item} value={item}>
                          {CompanyEnum[item]}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col lg={4} md={6} sm={12}>
                    <Form.Label> وضعیت سفارش:</Form.Label>
                    <Form.Select
                      type="text"
                      name="status"
                      value={this.state.status}
                      onChange={e => this.setState({ status: e.target.value })}
                    >
                      <option value="">همه</option>
                      <option value="تایید نهایی">تایید نهایی</option>
                      <option value="جمع آوری نشده">جمع آوری نشده</option>
                      <option value="ارجاع به راننده">ارجاع به راننده</option>
                      <option value="تحویل داده شده">
                        تحویل سرویس دهنده (در حال جابجایی)
                      </option>
                      <option value="معلق">بر صف پردازش (آماده ارسال)</option>
                      <option value="برگشتی">برگشتی</option>
                      <option value="تحویل مشتری">تحویل مشتری</option>
                      <option value="لغو موقت">لغو موقت</option>
                      <option value="لغو شده">لغو شده</option>
                    </Form.Select>
                  </Col>

                  <Col lg={4} md={6} sm={12}>
                    <Form.Label>نوع پرداخت:</Form.Label>
                    <Form.Select
                      type="text"
                      name="method_payment"
                      value={this.state.method_payment}
                      onChange={e =>
                        this.setState({ method_payment: e.target.value })
                      }
                    >
                      <option value="">همه</option>
                      <option value="پسکرایه">پسکرایه</option>
                      <option value="پیش کرایه">پیش کرایه</option>
                      <option value="پرداخت در محل-COD">
                        پرداخت در محل-COD
                      </option>
                    </Form.Select>
                  </Col>

                  <Col lg={4} md={6} sm={12}>
                    <Form.Label>وزن(کیلوگرم):</Form.Label>
                    <Form.Control
                      type="number"
                      name="weight"
                      style={{ height: "36px" }}
                      value={this.state.weight}
                      onChange={e => this.setState({ weight: e.target.value })}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col lg={4} md={6} sm={12}>
                    <Form.Label>نام گیرنده:</Form.Label>
                    <Form.Control
                      type="text"
                      name="getterName"
                      style={{ height: "36px" }}
                      value={this.state.getterName}
                      onChange={e =>
                        this.setState({ getterName: e.target.value })
                      }
                    />
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <Form.Label>استان گیرنده:</Form.Label>
                    <Form.Select
                      type="text"
                      name="getterProvince"
                      onChange={e => {
                        this.getCitiesMyPack(e.target.value, "reciver");
                        this.setState({ getterProvince: e.target.value });
                      }}
                    >
                      <option value="">...</option>
                      {this.state.provinces.map((item, idx) => (
                        <option key={idx} value={item.id}>
                          {item.faName}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <Form.Label>شهر گیرنده:</Form.Label>
                    <div className="dropdown-container">
                      <Select
                        name="getterCity"
                        options={this.state.cityOptionReciverMyPack}
                        placeholder="..."
                        onChange={data => {
                          this.setState({ getterCity: data.value });
                        }}
                        isSearchable={true}
                        onKeyDown={e => handleEnter(e)}
                        style={{ backgroundColor: "#ceccd1" }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col lg={4} md={6} sm={12}>
                    <Form.Label>نام فرستنده:</Form.Label>
                    <Form.Control
                      type="text"
                      name="senderName"
                      style={{ height: "36px" }}
                      value={this.state.senderName}
                      onChange={e =>
                        this.setState({ senderName: e.target.value })
                      }
                    />
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <Form.Label>استان فرستنده:</Form.Label>
                    <Form.Select
                      type="text"
                      name="senderProvince"
                      onChange={e => {
                        this.getCitiesMyPack(e.target.value, "sender");
                        this.setState({ senderProvince: e.target.value });
                      }}
                    >
                      <option value="">...</option>
                      {this.state.provinces.map((item, idx) => (
                        <option key={idx} value={item.id}>
                          {item.faName}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <Form.Label>شهر فرستنده:</Form.Label>
                    <div className="dropdown-container">
                      <Select
                        name="senderCity"
                        options={this.state.cityOptionSenderMyPack}
                        placeholder="..."
                        onChange={data => {
                          this.setState({ senderCity: data.value });
                        }}
                        isSearchable={true}
                        onKeyDown={e => handleEnter(e)}
                        style={{ backgroundColor: "#ceccd1" }}
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>
              <Row className="d-flex align-items-center justify-content-center m-5">
                <Col
                  lg={6}
                  md={6}
                  sm={12}
                  className="d-flex align-items-center justify-content-center"
                  ref={this.myRef}
                >
                  {this.state.loading ? (
                    <button
                      className="d-flex align-items-center btn-success-style"
                      type="button"
                      disabled
                    >
                      <span
                        className="spinner-border spinner-border-sm ml-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span className="me-3">در حال جستجو</span>
                    </button>
                  ) : (
                    <button
                      className="btn-success-style mt-1 px-5"
                      type="button"
                      onClick={() => {
                        this.setState(
                          { showSearchBox: true, pageNumber: 1 },
                          () => this.getData()
                        );
                      }}
                    >
                      جستجو
                    </button>
                  )}
                </Col>
              </Row>
              <div className="pb-2 pe-3 text-success fw-bold">
                <span>تعداد مرسولات: </span>
                <span>{this.state.count?.toLocaleString()}</span>
              </div>
            </Form>
          </div>
        </div>
      </Card>
    );

    const table = (
      <div className="overflow-x-scroll">
        <Table striped bordered={true} className={style.table}>
          <thead>
            <tr>
              <th className="text-center">#</th>
              <th className="text-center">شماره سفارش</th>
              <th className="text-center">نام فرستنده</th>
              <th className="text-center">مقصد</th>
              <th className="text-center">سرویس دهنده</th>
              <th className="text-center">بارکد</th>
              <th className="text-center">نوع پرداخت</th>
              <th className="text-center">مبلغ فاکتور</th>
              <th className="text-center">وضعیت</th>
              <th className="text-center">مالی</th>
              <th className="text-center">تاریخ</th>
              <th className="text-center">انتخاب</th>
            </tr>
          </thead>
          <tbody>
            {this.state.loading === true && (
              <tr>
                <td colSpan={12}>
                  <Loader />
                </td>
              </tr>
            )}
            {this.state.loading === false &&
              this.state.users.map((factor, index) => (
                <tr key={index} className="align-middle">
                  <td>{index + this.state.startNumber}</td>
                  <td>
                    <PrintLink ids={[factor.factor.id]}>
                      {factor.factor.numberParcel}
                    </PrintLink>
                  </td>

                  <td>
                    {factor.factor.source?.type === 0 && (
                      <Fragment>
                        <span>{factor.factor.source?.name} </span>
                        <span>{factor.factor.source?.family}</span>
                      </Fragment>
                    )}
                    {factor.factor.source?.type === 1 && (
                      <span>{factor.factor.source?.compony}</span>
                    )}
                  </td>

                  <td>
                    <span>{factor.factor.destination?.province?.faName}</span>
                    <span> {factor.factor.destination?.city?.faName} - </span>
                    {factor.factor.destination?.type === 0 && (
                      <Fragment>
                        <span>{factor.factor.destination?.name} </span>
                        <span>{factor.factor.destination?.family}</span>
                      </Fragment>
                    )}
                    {factor.factor.destination?.type === 1 && (
                      <span>{factor.factor.destination?.compony}</span>
                    )}
                  </td>

                  <td>{factor.compony ? factor.compony?.name : ""}</td>

                  <td>{findBarcode(factor)}</td>

                  <td>
                    {factor.factor.MethodPayment === "پیش کرایه" && (
                      <span>پیش کرایه</span>
                    )}

                    {factor.factor.MethodPayment === "پیشکرایه" && (
                      <span>پیش کرایه</span>
                    )}

                    {factor.factor.MethodPayment === "پرداخت در محل-COD" &&
                      factor.factor.amountCOD > 0 && (
                        <span>پرداخت در محل-COD</span>
                      )}
                    {factor.factor.MethodPayment === "پرداخت در محل-COD" &&
                      factor.factor.amountCOD === 0 && <span>پسکرایه</span>}
                  </td>

                  <td>
                    {(
                      factor.factor.realPayable + factor.factor.amountCOD
                    ).toLocaleString()}
                    <span> ريال</span>
                  </td>
                  <td>{getShipmentStatus(factor.factor.status)}</td>
                  <td>
                    <button
                      onClick={() => {
                        this.showPartsInModal(index);
                      }}
                      className="buttonUi text-primary"
                    >
                      مشاهده
                    </button>
                  </td>
                  <td>
                    <span
                      style={{ whiteSpace: "pre-line" }}
                    >{`${factor.date}\n${factor.time}`}</span>
                  </td>
                  <td className="align-middle">
                    <input
                      style={{ width: 25, height: 25 }}
                      type="checkbox"
                      className="c-pointer"
                      checked={this.state.checkBoxesValue[index]}
                      onChange={e => {
                        this.setChecked(
                          e.target.checked,
                          index,
                          factor.factor.id
                        );
                      }}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    );

    const optionArew = (
      <div className="m-2 d-flex flex-wrap align-items-center">
        <Col xs={6} sm={4} lg={2} className="my-2">
          <Form.Label>تعداد نمایش:</Form.Label>
          <Form.Select
            id="disabledSelect"
            value={this.state.showNumber}
            onChange={this.setInputNumber}
          >
            <option>10</option>
            <option>20</option>
            <option>50</option>
            <option>100</option>
            <option>200</option>
            <option>500</option>
          </Form.Select>
        </Col>

        <Col lg={2} md={3} sm={3} xs={5} className="text-center my-2 me-auto">
          <Button
            className="fw-bold btn-success-style w-100 text-center"
            onClick={() => this.selectAll()}
          >
            انتخاب همه
          </Button>
        </Col>

        <Col lg={2} md={3} sm={3} xs={5} className="text-center my-2 me-2">
          <PrintLink
            ids={this.state.selectedValue}
            className="btn text-center text-white fw-bold btn-cancel-style w-100"
          >
            پرینت فاکتور
          </PrintLink>
        </Col>

        <Col lg={2} md={3} sm={3} xs={5} className="text-center my-2 me-2">
          <PrintLabelButton
            ids={this.state.selectedValue}
            className="btn text-center text-white fw-bold btn-cancel-style w-100"
          >
            پرینت لیبل
          </PrintLabelButton>
        </Col>
      </div>
    );

    const excelBtn = (
      <ExcelDownload
        config={{
          method: "POST",
          url: "/totalpost/v1/mypart",
          data: {
            startDate: this.state.startDate.toString(),
            endDate: this.state.endDate.toString(),
            numberParcel: this.state.numberParcel,
            componyId: this.state.componyId,
            status: this.state.status,
            weight: this.state.weight,
            getterName: this.state.getterName,
            getterProvince: this.state.getterProvince,
            getterCity: this.state.getterCity,
            senderName: this.state.senderName,
            senderProvince: this.state.senderProvince,
            senderCity: this.state.senderCity,
            method_payment: this.state.method_payment,
            isExcel: 1,
          },
        }}
      />
    );

    const paginate = (
      <div className="my-4">
        <PaginateCard
          count={this.state.count}
          numberItems={this.state.showNumber}
          numberPage={this.state.pageNumber}
          onIndexChoose={number =>
            this.setState({ pageNumber: number }, () => {
              this.getData();
              this.myRef.current.scrollIntoView({ behavior: "instant" });
            })
          }
        />
      </div>
    );

    return (
      <Container className="rtl-all">
        <h1 className="mb-4 fw-semibold">مرسولات من</h1>

        {filter}
        <Card className="tableOption">
          {optionArew}
          {table}
          {paginate}

          <div className="d-flex flex-wrap p-2 gap-2">
            {excelBtn}
            <DownloadReport state={this.state} />
          </div>
        </Card>

        <OrderDetailModal
          state={this.state}
          onClose={() => this.setState({ showModal: false })}
        />
      </Container>
    );
  }
}
